// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://cdn.jsdelivr.net/npm/vue2-daterange-picker@0.6.8/dist/vue2-daterange-picker.css);"]);
// Module
exports.push([module.id, ".customRangeStyles.vue-daterange-picker div.form-control.reportrange-text {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: 48px !important;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  background: inherit;\n  font-size: 14px;\n  color: #2d3748;\n  border-color: #cbd5e0;\n}", ""]);
// Exports
module.exports = exports;
